// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2t6XK","col":"styles_col__2s5fy","fulfillmentStatus":"styles_fulfillmentStatus__2-6p6","emailCol":"styles_emailCol__2NFnr"};